<template>
  <div class="form-row">
    <div class="form-row__item group-thumbnail">
      <img :src="src" class="group-thumbnail__preview" alt="" />
    </div>
    <div class="form-row__item group-thumbnail__actions">
      <label class="btn group-thumbnail__input-button"
        >Upload image<input
          type="file"
          @change="fileChange"
          :value="file"
          name="group[picture]"
          class="group-thumbnail__file-input"
          accept=".gif,.jpg,.jpeg,.png"/></label
      ><input
        type="hidden"
        name="group[picture_destroy]"
        :value="toBeDeleted"
      /><button
        v-show="isRemovable"
        class="btn group-thumbnail__destroy-button"
        @click.prevent="setToBeDeleted"
      >
        Remove image
      </button>
    </div>
  </div>
</template>
<script>
export default {
  name: "GroupThumbnail",
  props: ["placeholderSrc", "imageSrc", "exists"],
  data () {
    return {
      src: null,
      toBeDeleted: false,
      file: ""
    };
  },

  computed: {
    isRemovable () {
      return this.src !== this.placeholderSrc;
    }
  },

  mounted () {
    this.src = this.imageSrc;
  },
  methods: {
    setPlaceholder () {
      this.src = this.placeholderSrc;
    },
    setToBeDeleted () {
      this.file = "";
      this.toBeDeleted = true;
      this.setPlaceholder();
    },
    fileChange (event) {
      this.file = event.currentTarget.value;
      let file = event.currentTarget.files[0];
      let reader = new FileReader();

      reader.addEventListener(
        "load",
        () => {
          this.src = reader.result;
        },
        false
      );

      if (file) {
        reader.readAsDataURL(file);
      }
    }
  }
};
</script>
